import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  error: null,
};

const { Types, Creators } = createActions(
  {
    requestPoints: ['businessId', 'resolve'],
    requestPointsRequest: [],
    requestPointsSuccess: [],
    requestPointsFailure: ['error'],
  },
  { prefix: 'cb/customerPointsRequest/' },
);

export { Types as types, Creators as actions };

const request = state => ({ ...state, fetching: true, error: null });
const success = state => ({ ...state, fetching: false, fetched: true });
const failure = (state, { error }) => ({ ...state, fetching: false, fetched: true, error });

export const HANDLERS = {
  [Types.REQUEST_POINTS_REQUEST]: request,
  [Types.REQUEST_POINTS_SUCCESS]: success,
  [Types.REQUEST_POINTS_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
